// components/CurrencySelector.jsx
import React from 'react';
import { DollarSign } from 'lucide-react';
import './CurrencySelector.css';

const currencies = [
    { code: 'USD', symbol: '$', name: 'US Dollar' },
    { code: 'EUR', symbol: '€', name: 'Euro' },
    { code: 'GBP', symbol: '£', name: 'British Pound' }
];

const CurrencySelector = ({ selectedCurrency, onCurrencyChange }) => {
    return (
        <div className="currency-selector">
            <div className="currency-selector-wrapper">
                <DollarSign className="currency-icon" size={16} />
                <select 
                    value={selectedCurrency} 
                    onChange={(e) => onCurrencyChange(e.target.value)}
                    className="currency-select"
                >
                    {currencies.map(currency => (
                        <option key={currency.code} value={currency.code}>
                            {currency.symbol} {currency.code}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default CurrencySelector;
